<template>
  <div class="hitchRidePricingRule">
    <custom-city-tree @city-selected="handleCitySelect" url="/api/v1/manage/hitchRide/city"/>

      <div class="hitchRidePricingRule-content">
        <hitchRideForm :cityData="{ ...selectCity }"></hitchRideForm>
      </div>
  </div>
</template>

<script>
import CustomCityTree from './components/CustomCityTree.vue';
import hitchRideForm from './components/hitchRideForm.vue'
export default {
  components: { CustomCityTree, hitchRideForm },
  data() {
    return {
      selectCity: {}
    };
  },
  computed: {},
  created() {
    
  },
  methods: {
    handleCitySelect(node) {
      this.selectCity = node;
    }
  }
};
</script>

<style lang="less" scoped>
.hitchRidePricingRule{
  display: flex;

  &-content {
    padding: 16px;
    flex: 1;
    max-height: calc(100vh - 240px);
    overflow-y: auto;
  }
}
</style>